import React, { useState, useEffect } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";

export default function Brand() {
  const [Data, setData] = useState();
  const [Loading, setLoading] = useState(true);
  const [MyWidth, setMyWidth] = useState(window.innerWidth);
  const history = useHistory();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${MyDomain}Brands/GetBrands`);
        setData(response.data);
        console.log(response.data);
      } catch (err) {
        //setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);
  const alphabet = Array.from(
    { length: 26 },
    (_, index) => String.fromCharCode(65 + index) // 65 is the ASCII code for 'A'
  );
  // Add "All" and "0-9" to the beginning of the array
  const options = ["All", "0-9", ...alphabet];

  // State to keep track of the selected item
  const [selectedItem, setSelectedItem] = useState(null);

  const handleDivClick2 = (CategoryTitle, NameOfCategory) => {
    history.push({
      pathname: `/Brand/${NameOfCategory}`,
      state: { CategoryTitle }, // Pass CategoryName here
    });
    //setVisiblePopoverIndex(null);
  };
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        justifyContent: "center",
        flexDirection: "column",
        paddingRight: MyWidth <= 1024 ? "2%" : "0%",
        paddingLeft: MyWidth <= 1024 ? "2%" : "0%",
      }}
    >
      <div
        style={{
          display: "flex",
          width: "100%",
          justifyContent: "center",
          paddingTop: 40,
          paddingBottom: 20,
        }}
      >
        <a>{t("categories.Brands")}</a>
      </div>
      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        <div style={{ display: "flex", width: MyWidth <= 1024 ? "0%" : "25%" }}>
          {/* aa */}
        </div>
        <div
          style={{
            display: "flex",
            width: MyWidth <= 1024 ? "100%" : "75%",
            flexDirection: "column",
          }}
        >
          {/* <div
            style={{
              display: "flex",
              flexWrap: "wrap", // Enable wrapping
              width: "100%",
              paddingBottom: 80,
            }}
          >
            {options.map((item, index) => (
              <div
                key={index}
                style={{
                  display: "flex",
                  border: "1px solid #e4e4e7",
                  width: 50,
                  height: 35,
                  //padding: "5px 20px", // Shorthand for top/bottom 5px, left/right 20px
                  textAlign: "center", // Center the text
                  boxSizing: "border-box", // Include padding and border in the element's dimensions
                  marginLeft: "-1px", // Offset the left border to prevent doubling
                  marginTop: "-1px", // Offset the top border to prevent doubling
                  backgroundColor: selectedItem === item ? "black" : "white", // Change background color if selected
                  cursor: "pointer", // Change cursor to pointer on hover
                  //transition: "background-color 0.3s ease", // Smooth transition for background color
                  justifyContent: "center",
                  alignItems: "center",
                }}
                onClick={() => setSelectedItem(item)} // Update the selected item on click
                onMouseEnter={(e) => {
                  if (selectedItem !== item) {
                    e.currentTarget.style.backgroundColor = "#f0f0f0"; // Change background color on hover
                  }
                }}
                onMouseLeave={(e) => {
                  if (selectedItem !== item) {
                    e.currentTarget.style.backgroundColor = "white"; // Revert background color on mouse leave
                  }
                }}
              >
                <a
                  style={{
                    fontSize: 14,
                    color: selectedItem === item ? "white" : "black",
                  }}
                >
                  {item}
                </a>
              </div>
            ))}
          </div> */}
          <div style={{ width: "100%", display: "flex" }}>
            <div
              style={{
                width: "100%",
              }}
            >
              {Loading ? (
                <>
                  <a>Loading...</a>{" "}
                </>
              ) : (
                <>
                  {/* {Data.map((item, index) => (
                    <div key={index} style={{}}>
                      <a
                        style={{
                          fontSize: 14,
                        }}
                      >
                        {item.name}
                      </a>
                    </div>
                  ))} */}
                  {/* <div
                    style={{
                      display: "flex",
                      flexWrap: "wrap", // Enable wrapping
                      width: "100%",
                      paddingBottom: 80,
                    }}
                  >
                    {Data.map((item, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          border: "1px solid #e4e4e7",
                          // width: 50,
                          height: 35,
                          textAlign: "center",
                          boxSizing: "border-box",
                          marginLeft: "-1px",
                          marginTop: "-1px",
                          paddingLeft: 15,
                          paddingRight: 15,
                          // backgroundColor:
                          //   selectedItem === item ? "black" : "white", // Change background color if selected
                          cursor: "pointer",
                          //transition: "background-color 0.3s ease", // Smooth transition for background color
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                        //onClick={() => setSelectedItem(item)} // Update the selected item on click
                      >
                        <a
                          style={{
                            fontSize: 14,
                            //color: selectedItem === item ? "white" : "black",
                          }}
                        >
                          {item.name}
                        </a>
                      </div>
                    ))}
                  </div> */}

                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(3, 1fr)",
                      height: "80%",
                    }}
                  >
                    {Data.map((product, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          width: "100%",
                          border: "1px solid #ccc",
                          cursor: "pointer",
                          justifyContent: "center",
                          alignItems: "center",
                          padding: 15,
                        }}
                        onClick={() => {
                          handleDivClick2(product.name, product.codeBrand);
                        }}
                        onMouseEnter={(e) => {
                          if (selectedItem !== product) {
                            e.currentTarget.style.backgroundColor = "#f0f0f0"; // Change background color on hover
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (selectedItem !== product) {
                            e.currentTarget.style.backgroundColor = "white"; // Revert background color on mouse leave
                          }
                        }}
                      >
                        <a style={{ margin: 0, fontSize: 14, fontWeight: 500 }}>
                          {product.name}
                        </a>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
